import * as httpHolder from './httpHolder';
import * as icnServices from 'services/apis/calAmp/icnServices';
import moment from 'moment';

/**
 *
 * @param {angolo del pdof} angle
 */
export function getPdofImage(angle){

    var request =
        {
            angle
        };

    return httpHolder.getInstance().post('ICN/CreatePdofImage', request);
}

/**
 * DENT - predictive image
 * @param {*} pdof
 * @param {*} severityCode
 * @param {*} vehicleClass
 */
export function getPredictiveImage(pdof, severityCode, vehicleClass){

    var request =
        {
            pdof,
            severityCode,
            vehicleClass
        };

    return httpHolder.getInstance().post('PredictiveCarDamage/GetPredictiveCarDamage', request);
}

/**
 *
 * @param {icn id} id
 * @param {page type: 1 - icn, 2 - icnplus, 3 - dent} type
 */
export function ExportSingleToExcel(id, pageType) {
    var request =
    {
        id,
        pageType
    };

    return httpHolder.getInstance().post('ExportData/ExportSingleToExcel', request);
}

/**
 *
 * @param {icn id} id
 * @param {page type: 1 - icn, 2 - icnplus, 3 - dent} type
 * @param {version: 1 - standard template, 2 - new template for ANIA} version
 */
export function ExportSingleToPdf(id, pageType, version) {
    var request =
    {
        id,
        pageType,
        version: version != null ? version : 1
    };

    return httpHolder.getInstance().post('ExportData/ExportSingleToPdf', request);
}




/**
 *
 * @param {icn id} id
 * @param {page type: 1 - icn, 2 - icnplus, 3 - dent} type
 */
export function ExportSingleToCsv(id, pageType) {
    var request =
    {
        id,
        pageType
    };

    return httpHolder.getInstance().post('ExportData/ExportSingleToCsv', request);
}

export function exportListToExcel(list, pageType) {
    //Invoke api service
    var request =
    {
        list,
        pageType
    };

    return httpHolder.getInstance().post('ExportData/ExportListToExcel', request);
}

export function exportListToPdf(list, pageType, version) {
    //Invoke api service
    var request =
    {
        list,
        pageType,
        version
    };

    return httpHolder.getInstance().post('ExportData/ExportListToPdf', request);
}

export function exportListToCsv(list, pageType) {
    //Invoke api service
    var request =
    {
        list,
        pageType
    };

    return httpHolder.getInstance().post('ExportData/ExportListToCsv', request);
}

export function getRequestForAllList(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccounts, pageType){

        if(includeSubAccounts === undefined)
        {
            includeSubAccounts = true;
        }

        var dateFromUtc =moment(dateFrom).format("YYYY-MM-DD")
        var dateToUtc = moment(dateTo).format("YYYY-MM-DD")

        var request =
        {
            accountId: null,
            icnId: null,
            vin: null,
            deviceId: null,
            deviceIdType: null,
            dateFrom: dateFromUtc,
            dateTo: dateToUtc,
            severityCodeList: null,
            eventClassificationList: null,
            assetId: null,
            pageType,
            includeSubAccounts
        };

        if(icnId)
        {
            request.icnId = icnId;
        }

        if (account) {
            request.accountId = account.id;
        }

        if (vehicle && vehicle.id) {
            request.assetId = vehicle.id;
        }

        if (device && device.esn) {
            request.deviceId = device.esn;
            // per poter filtrare per ESN
            request.deviceIdType = "ESN";
        }

        if (deviceFilterValue) {
            request.deviceId = deviceFilterValue;
            // per poter filtrare per ESN, Id, IMEI
            request.deviceIdType = deviceIdType;
        }

        if (vin) {
            request.vin = vin;
        }

        var severityFilters = icnServices.getSeverityFilters(severityList);

        if (severityFilters && severityFilters.length > 0) {
            request.severityCodeList = severityFilters;
        }

        if (selectedClassificationValue) {
            request.eventClassificationList = selectedClassificationValue;
        }

        return request;

}

export function exportAllListToExcel(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccount, pageType) {

    // todo search by assetId
    var request = getRequestForAllList(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
        selectedClassificationValue, includeSubAccount, pageType);

    return httpHolder.getInstance().post('ExportData/ExportAllListToExcel', request);

}

export function exportAllListToPdf(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccount, pageType) {

    // todo search by assetId
    var request = getRequestForAllList(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
        selectedClassificationValue, includeSubAccount, pageType);

    return httpHolder.getInstance().post('ExportData/ExportAllListToPdf', request);

}

export function exportAllListToCsv(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccount, pageType) {

    // todo search by assetId
    var request = getRequestForAllList(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
        selectedClassificationValue, includeSubAccount, pageType);

    return httpHolder.getInstance().post('ExportData/ExportAllListToCsv', request);

}


// WEBPACK FOOTER //
// ./src/services/apis/crashboxx/crashboxxServices.js